/* global axios */
import ApiClient from './ApiClient';

class KraftchatAIAPI extends ApiClient {
  constructor() {
    super('kraftchat_ai', { accountScoped: true });
  }

  getProviderCredentials() {
    return axios.get(`${this.url}/provider_credentials`);
  }

  createProviderCredential(data) {
    return axios.post(`${this.url}/provider_credentials`, data);
  }

  updateProviderCredential(id, data) {
    return axios.patch(`${this.url}/provider_credentials/${id}`, data);
  }

  deleteProviderCredential(id) {
    return axios.delete(`${this.url}/provider_credentials/${id}`);
  }

  testProviderCredential(id) {
    return axios.post(`${this.url}/provider_credentials/${id}/test`);
  }

  getAgents() {
    return axios.get(`${this.url}/agents`);
  }

  getEligibleInboxes() {
    return axios.get(`${this.url}/agents/eligible_inboxes`);
  }

  getAgent(id) {
    return axios.get(`${this.url}/agents/${id}`);
  }

  createAgent(data) {
    return axios.post(`${this.url}/agents`, data);
  }

  updateAgent(id, data) {
    return axios.patch(`${this.url}/agents/${id}`, data);
  }

  deleteAgent(id) {
    return axios.delete(`${this.url}/agents/${id}`);
  }

  getAgentPolicies() {
    return axios.get(`${this.url}/agent_policies`);
  }

  getAgentPolicy(id) {
    return axios.get(`${this.url}/agent_policies/${id}`);
  }

  createAgentPolicy(data) {
    return axios.post(`${this.url}/agent_policies`, data);
  }

  updateAgentPolicy(id, data) {
    return axios.patch(`${this.url}/agent_policies/${id}`, data);
  }

  getKnowledgeDocuments(params = {}) {
    return axios.get(`${this.url}/knowledge_documents`, { params });
  }

  getKnowledgeDocument(id) {
    return axios.get(`${this.url}/knowledge_documents/${id}`);
  }

  createKnowledgeDocument(data) {
    return axios.post(`${this.url}/knowledge_documents`, data);
  }

  updateKnowledgeDocument(id, data) {
    return axios.patch(`${this.url}/knowledge_documents/${id}`, data);
  }

  deleteKnowledgeDocument(id) {
    return axios.delete(`${this.url}/knowledge_documents/${id}`);
  }

  simulatePlayground(data) {
    return axios.post(`${this.url}/playground/simulate`, data);
  }

  updateConversationAiControl(conversationId, active) {
    return axios.patch(
      `${this.url}/conversations/${conversationId}/ai_control`,
      {
        active,
      }
    );
  }
}

export default new KraftchatAIAPI();
